import { Navigate, Route, Routes } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import RequireAuth from './RequireAuth';
import PublicLayout from '../layouts/PublicLayout';
import AdminLayout from '../layouts/AdminLayout';
import About from '../pages/public/About';
import Blog from '../pages/public/Blog';
import Home from '../pages/public/Home';
import NotFound from '../pages/public/NotFound';
import PostDetail from '../pages/public/PostDetail';
import Projects from '../pages/public/Projects';
import Login from '../pages/admin/Login';
import Dashboard from '../pages/admin/Dashboard';
import AdminPosts from '../pages/admin/AdminPosts';
import PostEditor from '../pages/admin/PostEditor';
import AdminProjects from '../pages/admin/AdminProjects';
import ProfileEdit from '../pages/admin/ProfileEdit';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* 公开站点 */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<PostDetail />} />
        </Route>

        {/* 后台登录（独立布局） */}
        <Route path="/admin/login" element={<Login />} />

        {/* 后台管理（鉴权） */}
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="posts" element={<AdminPosts />} />
          <Route path="posts/new" element={<PostEditor />} />
          <Route path="posts/:id/edit" element={<PostEditor />} />
          <Route path="projects" element={<AdminProjects />} />
          <Route path="profile" element={<ProfileEdit />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}
